import React from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { useMetaPixel } from './hooks/useMetaPixel';
import { META_PIXEL_ID } from './data/content';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="23vkuoemiy5k6">
      <div className="min-h-screen w-full bg-blanco font-sans text-azul selection:bg-dorado selection:text-azul" data-id="element-1" data-mp="23ujl6el5pr4k">
        <noscript data-id="element-2" data-mp="3ijpc2xoqyt86">
          <img height="1" width="1" style={{
          display: 'none'
        }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-3" data-mp="3ii4ro0w5cqo1" />
        </noscript>

        <Hero data-id="element-4" data-mp="6801qozk67w" />
        <main data-id="element-5" data-mp="4n5i12o8na1">
          <ProblemSection data-id="element-6" data-mp="56nfhsbnbo2" />
          <SolutionSection data-id="element-7" data-mp="7sxpp6lk59z" />
          <BonusesSection data-id="element-8" data-mp="2zllijblcf2rh" />
          <BenefitsSection data-id="element-9" data-mp="2zmemk4sx3e5x" />
          <OfferSection data-id="element-10" data-mp="2zn66ujh2dpgw" />
          <GuaranteeSection data-id="element-11" data-mp="33mf1rrnubte1" />
          <Testimonials data-id="element-12" data-mp="33nq5jrhad155" />
          <FAQSection data-id="element-13" data-mp="33myn7icp8zwt" />
          <FinalCTA data-id="element-14" data-mp="33ohzyyz5cstu" />
        </main>
        <Footer data-id="element-15" data-mp="38li7lebna3n2" />
        <PurchasePopup data-id="element-16" data-mp="38l05w267qx7r" />
      </div>
    </MotionConfig>;
}